import { Button } from "@material-ui/core";
import React from "react";
import { auth, provider } from "../firebase";
import "./Login.css";

const signIn = () => {
  auth.signInWithPopup(provider).catch((error) => alert(error.message));
};

const Login = () => {
  return (
    <div className="login">
      <div className="login__logo">
        <img src="" alt="logo" />
      </div>
      <Button onClick={signIn}>Sign In</Button>
    </div>
  );
};

export default Login;
